/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillDetailGoodsVo
 */
export interface BillDetailGoodsVo {
    /**
     * ID
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    id?: number;
    /**
     * 账单ID
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    billId?: number;
    /**
     * 实际重量
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    realWeight?: number;
    /**
     * 体积重量
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    volumnWeight?: number;
    /**
     * 体积合计
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    volumnSum?: number;
    /**
     * 体积（CBM）
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    cbm?: number;
    /**
     * 箱子长
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    length?: number;
    /**
     * 箱子宽
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    width?: number;
    /**
     * 箱子高
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    height?: number;
    /**
     * 体积适用率
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    volumnApplyRate?: number;
    /**
     * 追加快递费用
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    addDeliveryFee?: number;
    /**
     * 适用重量
     * @type {number}
     * @memberof BillDetailGoodsVo
     */
    applyWeight?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof BillDetailGoodsVo
     */
    createTime?: string;
    /**
     * 修改时间
     * @type {string}
     * @memberof BillDetailGoodsVo
     */
    updateTime?: string;
}

/**
 * Check if a given object implements the BillDetailGoodsVo interface.
 */
export function instanceOfBillDetailGoodsVo(value: object): value is BillDetailGoodsVo {
    return true;
}

export function BillDetailGoodsVoFromJSON(json: any): BillDetailGoodsVo {
    return BillDetailGoodsVoFromJSONTyped(json, false);
}

export function BillDetailGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillDetailGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'billId': json['billId'] == null ? undefined : json['billId'],
        'realWeight': json['realWeight'] == null ? undefined : json['realWeight'],
        'volumnWeight': json['volumnWeight'] == null ? undefined : json['volumnWeight'],
        'volumnSum': json['volumnSum'] == null ? undefined : json['volumnSum'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'volumnApplyRate': json['volumnApplyRate'] == null ? undefined : json['volumnApplyRate'],
        'addDeliveryFee': json['addDeliveryFee'] == null ? undefined : json['addDeliveryFee'],
        'applyWeight': json['applyWeight'] == null ? undefined : json['applyWeight'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
        'updateTime': json['updateTime'] == null ? undefined : json['updateTime'],
    };
}

export function BillDetailGoodsVoToJSON(json: any): BillDetailGoodsVo {
    return BillDetailGoodsVoToJSONTyped(json, false);
}

export function BillDetailGoodsVoToJSONTyped(value?: BillDetailGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'billId': value['billId'],
        'realWeight': value['realWeight'],
        'volumnWeight': value['volumnWeight'],
        'volumnSum': value['volumnSum'],
        'cbm': value['cbm'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'volumnApplyRate': value['volumnApplyRate'],
        'addDeliveryFee': value['addDeliveryFee'],
        'applyWeight': value['applyWeight'],
        'createTime': value['createTime'],
        'updateTime': value['updateTime'],
    };
}

